import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
import { Colors } from '../../../layout/theme-next';

export const StyledLabel = styled('label')(({ theme }) => ({
  color: Colors.textBlack,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: '15px',
  marginBottom: theme.spacing(1),
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiAutocomplete-inputRoot': {
    paddingRight: theme.spacing(3.75),
  },
  '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
    transform: 'translate(14px, 14px) scale(0.75)',
    color: Colors.textGray,
  },
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  background: Colors.primaryBg,
  borderRadius: 2,
  height: 30,
  margin: theme.spacing(1.25, 0),
  display: 'flex',
  justifyContent: 'space-between',
  overflow: 'hidden',
  position: 'relative',

  '& .MuiChip-label': {
    paddingLeft: theme.spacing(0.75),
  },

  '&:focus, &:active': {
    backgroundColor: Colors.primaryBg,
  },

  '&:hover': {
    '& .delete-icon': {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
}));

export const StyledChipLabel = styled('span')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.3,
  color: Colors.primary,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'block',
  textDecoration: 'none',

  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const StyledDeleteIcon = styled('span')(({ theme }) => ({
  opacity: 0,
  height: 14,
  width: 13,
  flexShrink: 0,
  position: 'absolute',
  right: 0,
  top: '-15%',
  transform: 'translateX(100%)',
  transition: theme.transitions.create(['opacity', 'transform'], { duration: 200 }),

  '&:hover': {
    color: Colors.error,
    cursor: 'pointer',
  },
}));

export const StyledOption = styled('li')({
  fontSize: 14,
  fontFamily: 'Sora',
  overflowWrap: 'anywhere',
});

export const StyledLink = styled(Link)({
  textDecoration: 'none',
});
